import type { PaletteOptions } from '@mui/material/styles'

import commonPalette from '../common/palette'

const palette: PaletteOptions = {
  ...commonPalette
}

export default palette
